import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
import { ref, reactive, onMounted } from 'vue';
const _hoisted_1 = {
  class: "mg-ui-my-org-audit-flow-cfg-list-view-wrapper"
};
export default {
  __name: 'my-org-audit-flow-cfg-list',
  setup(__props, {
    expose: __expose
  }) {
    const {
      runAsync: myOrgAuditFlowCfgListApi
    } = fetchApi('kpi.auditFlowCfg.myOrgGetCfgList');
    const list = ref([]);
    const selectRow = ref();
    const loadMyOrgAuditFlowCfgList = async () => {
      const {
        error,
        rows
      } = await myOrgAuditFlowCfgListApi({});
      if (error) return;
      list.value = rows;
    };
    const gridOptions = reactive({
      border: true,
      headerAlign: 'center',
      align: 'left',
      rowConfig: {
        keyField: 'id',
        isHover: true,
        isCurrent: true
      },
      columns: [{
        type: 'seq',
        field: '序号',
        width: 70,
        fixed: 'left'
      }, {
        field: 'name',
        title: '流程名称',
        width: 240
      }]
    });
    const handleSelectRowChanged = ({
      row
    }) => {
      selectRow.value = row;
    };
    onMounted(() => {
      loadMyOrgAuditFlowCfgList();
    });
    __expose({
      confirmListener() {
        return Promise.resolve(selectRow.value);
      }
    });
    return (_ctx, _cache) => {
      const _component_vxe_grid = _resolveComponent("vxe-grid");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_vxe_grid, _mergeProps(_unref(gridOptions), {
        data: _unref(list),
        height: "100%",
        onCurrentRowChange: handleSelectRowChanged
      }), null, 16, ["data"])]);
    };
  }
};